import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, AuditsReducer, AuditsState, initialState } from './audits-reducer';

const AuditsContext = createContext<AuditsState | undefined>(undefined);
const AuditsDispatchContext = createContext({} as any);

const AuditsProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(AuditsReducer, initialState);

    return (
        <AuditsContext.Provider value={state}>
            <AuditsDispatchContext.Provider value={dispatch}>
                {children}
            </AuditsDispatchContext.Provider>
        </AuditsContext.Provider>
    );
};

const useAuditsState = () => {
    const context = useContext(AuditsContext);
    if (context === undefined) {
        throw new Error('useAuditsState must be used within a AuditsProvider');
    }
    return context;
};

const useAuditsDispatch = () => {
    const context = useContext(AuditsDispatchContext);
    if (context === undefined) {
        throw new Error('useAuditsDispatch must be used within a AuditsProvider');
    }
    return context;
};

export { AuditsProvider, useAuditsState, useAuditsDispatch, ACTION_TYPES };
